import Vue from "vue";
import Router from "vue-router";
import deBontje from "./views/deBontje.vue";
import Datenschutz from "./views/Datenschutz.vue";
import Impressum from "./views/Impressum.vue";
import Gezeiten from "./views/Gezeiten.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "deBontje",
      components: { default: deBontje, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/datenschutz",
      name: "Datenschutz",
      components: {
        default: Datenschutz,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: { colorOnScroll: 200 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/impressum",
      name: "Impressum",
      components: {
        default: Impressum,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: { colorOnScroll: 200 }
      }
    },
    {
      path: "/gezeiten",
      name: "Gezeiten",
      components: {
        default: Gezeiten,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: { colorOnScroll: 0 }
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
